import React from "react";
import StockService from "services/stock";
import StockSupplierService from "services/stock-supplier";

import { connect } from "react-redux";
import { load } from "reducers/stock";

class Stock extends React.Component {
  stockService = new StockService();
  stockSupplierService = new StockSupplierService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.stockService.getAll().then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Stock);
